import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { SchedulerItemApiAbstract } from './item-api';
import { ApiRouteWorkOrderService } from '../../../api/elite/routes/work-order.service';
import { SchedulerAuthService } from '../services/auth.service';
import { TranslateService } from '@ngx-translate/core';
import { AlertService } from '../../../core/services/alert.service';
import { ApiRouteSchedulingService } from '../../../api/elite/routes/scheduling.service';
import { SubWorkOrder } from '../../../api/elite/types/sub-work-order';

@Injectable({
  providedIn: 'root',
})
export class SchedulerWorkOrderApiService extends SchedulerItemApiAbstract {
  protected readonly apiWorkOrderRouter = inject(ApiRouteWorkOrderService);
  protected readonly translateService = inject(TranslateService);
  protected readonly authService = inject(SchedulerAuthService);
  protected readonly alertService = inject(AlertService);
  private readonly apiSchedulingRouter = inject(ApiRouteSchedulingService);

  getSubWorkOrders(transactionId: number): Observable<SubWorkOrder[]> {
    return this.apiWorkOrderRouter.getSubWorkOrders(transactionId);
  }

  updateRank(workOrderId: number, rank: string): Observable<any> {
    return this.apiWorkOrderRouter.update(workOrderId, { rank });
  }

  modifyPriority(workOrderId: number, value: boolean): Observable<any> {
    if (!this.authService.canGivePriority()) {
      const authError = this.translateService.instant(
        'WORK_ORDER.ERROR.PRIORITY'
      );
      this.alertService.error(authError);
      return;
    }
    return this.apiWorkOrderRouter.update(workOrderId, { priority: value });
  }

  async deleteWo(workOrderId: number): Promise<Observable<any>> {
    if (!this.authService.eliminateWorkOrder()) {
      const authError = this.translateService.instant(
        'WORK_ORDER.ERROR.DELETE'
      );
      this.alertService.error(authError);
      return;
    }
    const deleteQuestion = this.translateService.instant('WORK_ORDER.DELETE');
    return this.alertService.warning(deleteQuestion).then((res) => {
      if (res.isConfirmed) {
        return this.apiSchedulingRouter.deleteWorkOrder(workOrderId);
      }
      return undefined;
    });
  }
}
